import { render } from "./DonemSecici.vue?vue&type=template&id=74b14a9b&scoped=true"
import script from "./DonemSecici.vue?vue&type=script&lang=js"
export * from "./DonemSecici.vue?vue&type=script&lang=js"

import "./DonemSecici.vue?vue&type=style&index=0&id=74b14a9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b14a9b"]])

export default __exports__